var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-scroll",on:{"click":_vm.scrollToNextSection}},[_c('svg',[_c('use',{attrs:{"xlink:href":"#scrollDownSvg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }